import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/opt/build/repo/node_modules/gatsby-theme-carbon/src/templates/Default.js";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const PageDescription = makeShortcode("PageDescription");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <PageDescription mdxType="PageDescription">
      <p>{`Dieser Bereich soll den Benutzer Entwickler-Ressourcen zur Verfügung stellen und darüber Informieren, wie die Ressource zu verwenden sind und wie damit gestartet werden kann.`}</p>
    </PageDescription>
    <h2>{`Erste Schritte`}</h2>
    <h3>{`Installiere React Pattern`}</h3>
    <p>{`Das Cranach Design basiert auf React und stellt vorzugsweise auch `}<a parentName="p" {...{
        "href": "./react-tutorial"
      }}>{`React-Komponenten`}</a>{` vorerst zur Verfügung.`}</p>
    <h3>{`Erkunde all unsere Developer Ressourcen`}</h3>
    <p>{`Im Bereich `}<a parentName="p" {...{
        "href": "./developer-ressources"
      }}>{`Developer Ressourcen`}</a>{` findest du Cranach Design Github Repositories und React Storybook`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      